import { createFileRoute } from "@tanstack/react-router";
import { seo, SITE_URL } from "@/lib/seo";
import { ClosingCta, MarketingPage } from "@/components/marketing/marketing-kit";

export const FAQS = [
  {
    q: "Is The Quantum Mind free?",
    a: "Yes. Syllabus tracking, the revision planner, the test tracker, question practice, simulations, virtual labs and the study toolkit are all free to use.",
  },
  {
    q: "Do I need an account to use it?",
    a: "No account is needed to explore the site, the toolkit, simulations and labs. You only need a free account when you want to save chapters, revisions, tests and scores, or sync them across devices.",
  },
  {
    q: "Is it useful for NEET as well as JEE?",
    a: "Yes. The tracker is subject-based, so Physics and Chemistry work identically for NEET aspirants, and the revision and test workflows are the same.",
  },
  {
    q: "How does the revision planner work?",
    a: "When you mark a lecture complete, the app schedules a series of spaced revisions for it. Each day you get the revisions that are due, and anything you miss carries forward.",
  },
  {
    q: "Can I track more than one test?",
    a: "Yes. You can create unlimited tests, each with its own schedule, task list, status and subject-wise score entry.",
  },
  {
    q: "Where is my data stored?",
    a: "Your progress is stored securely against your account so it is available on every device you sign in from.",
  },
  {
    q: "Can I install it like an app?",
    a: "Yes. The Quantum Mind is a progressive web app — use the install banner on Android or Share → Add to Home Screen on iPhone and iPad.",
  },
];

export const Route = createFileRoute("/faq")({
  head: () => {
    const base = seo({
      title: "FAQ — The Quantum Mind JEE Preparation Tracker",
      description:
        "Answers about pricing, accounts, revision scheduling, test tracking, data storage and installing The Quantum Mind JEE preparation tracker.",
      path: "/faq",
    });
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "@id": `${SITE_URL}/faq#faq`,
            mainEntity: FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        },
      ],
    };
  },
  component: FaqPage,
});

function FaqPage() {
  return (
    <MarketingPage>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        FAQ
      </p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">
        Frequently asked questions
      </h1>

      <div className="mt-8 space-y-4">
        {FAQS.map((f) => (
          <section key={f.q} className="glass rounded-3xl border border-hairline p-5">
            <h2 className="text-[15px] font-bold tracking-tight">{f.q}</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{f.a}</p>
          </section>
        ))}
      </div>

      <ClosingCta />
    </MarketingPage>
  );
}
